type Props = {
    className?: string;
};

export function NoDocuments({ className = '' }: Props) {
    return (
        <svg
            className={className}
            width="90"
            height="75"
            viewBox="0 0 90 75"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
        >
            <ellipse cx="42.9001" cy="64.7639" rx="39" ry="3.9" fill="#F9FAFB" />
            <rect
                x="37.1277"
                y="6.74535"
                width="37.2848"
                height="50.1206"
                rx="3.6"
                transform="rotate(11.0929 37.1277 6.74535)"
                fill="#EAECF0"
                stroke="#D0D5DD"
                strokeWidth="0.6"
                strokeLinecap="round"
                strokeLinejoin="round"
                strokeDasharray="1.2 2.4"
            />
            <rect
                x="12.7339"
                y="19.2014"
                width="37.2848"
                height="50.1206"
                rx="3.6"
                transform="rotate(-13.532 12.7339 19.2014)"
                fill="#F9FAFB"
                stroke="#D0D5DD"
                strokeWidth="0.6"
                strokeLinecap="round"
                strokeLinejoin="round"
                strokeDasharray="1.2 2.4"
            />
            <path
                d="M69.2197 62.8227L57.4734 51.0764C58.0185 50.7053 59.4995 49.1228 60.1719 48.378L71.9182 60.1243C72.5531 60.7592 73.696 62.1561 72.5531 63.2989C71.4102 64.4418 70.1721 63.7751 69.2197 62.8227Z"
                fill="#EAECF0"
                stroke="#D0D5DD"
                strokeWidth="0.6"
                strokeLinejoin="round"
            />
            <circle
                cx="49.6702"
                cy="40.5999"
                r="13.3935"
                transform="rotate(-45 49.6702 40.5999)"
                fill="#EAECF0"
                stroke="#D0D5DD"
                strokeWidth="0.6"
            />
            <circle
                cx="49.6716"
                cy="40.5999"
                r="10.6997"
                transform="rotate(-45 49.6716 40.5999)"
                fill="#F9FAFB"
                stroke="#D0D5DD"
                strokeWidth="0.6"
            />
            <path
                d="M45.6008 34.8389V40.0889M48.4133 37.4639L42.7883 37.4639"
                stroke="#EAECF0"
                strokeWidth="0.9"
                strokeLinecap="round"
                strokeLinejoin="round"
            />
        </svg>
    );
}
